import React, {PropTypes} from 'react';
import {Field, FieldArray, formValueSelector, initialize, reduxForm, SubmissionError} from 'redux-form';
import {connect} from 'react-redux';
import {Button} from 'react-bootstrap';
import TextareaControl from './../../FormTemplate/TextareaControl';
import axios from './../../../constants/axios';
import alert from 'alertify.js';
import RenderInventoryCounterList from './FormHelper/RenderItemList';

class EditSaleForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoiceDetails: {},
         loading: true,
      };
   }

   componentDidMount() {
      const {invoiceId} = this.props.params;
      let details = axios.get(`inventorySales/getInvoiceDetailsById/${invoiceId}`)
         .then((res) => res.data);
      let items = axios.get(`inventorySales/getInventoryItemsByInvoiceId/${invoiceId}`)
         .then((res) => res.data);

      Promise.all([details, items])
         .then(([invoiceDetails, invoiceItems]) => {
            this.setState({
               invoiceDetails: invoiceDetails,
               loading: false,
               items: invoiceItems.items
            });
            this.props.dispatch(initialize('editSaleForm', {
               items: invoiceItems.items,
               memo: invoiceDetails.memo,
            }));
         });
   }

   componentWillReceiveProps(nextProps) {
      if (nextProps.items && nextProps.items.length > 0) {
         nextProps.items.forEach((item) => {
            if (item.price && item.unit) {
               if (item.unit_discount) {
                  item.total = (item.price - item.unit_discount) * item.unit;
                  item.discount_percentage = (item.unit_discount * (100 / item.price)).toFixed(2);
               } else {
                  item.total = item.price * item.unit;
                  item.discount_percentage = 0;
               }
            } else {
               item.total = '';
            }
         });
      }
   }

   // loadInvoiceDetails = () => {
   //    const {invoiceId} = this.props.params;
   //    this.setState({
   //       loading: true,
   //    });
   //    axios.get(`inventorySales/getInvoiceDetailsById/${invoiceId}`)
   //       .then((res) => {
   //          this.setState({
   //             invoiceDetails: res.data,
   //             loading: false,
   //          });
   //       });
   // };
   //
   // getInvoiceInventoryItems = () => {
   //    const {invoiceId} = this.props.params;
   //    axios.get(`inventorySales/getInventoryItemsByInvoiceId/${invoiceId}`)
   //       .then((res) => {
   //          this.props.dispatch(initialize('editSaleForm', {
   //             items: res.data.items
   //          }));
   //       });
   // };

   submit = (values) => {
      const dataToSend = {
         memo: values.memo,
         items: values.items.map((i) => {
            return {
               item_id: i.item_id,
               unit: i.unit,
               price: i.price,
               unit_discount: i.unit_discount || 0,
            };
         })
      };
      const {invoiceId} = this.props.params;
      return axios.put('/inventorySales/putSaleItems/' + invoiceId, dataToSend)
         .then((res) => {
            if (res.status === 201) {
               alert.success('invoice created.');
               this.context.router.push('/sale/saleInvoiceDetail/' + res.data.invoice_id);
            } else {
               alert.error('Something went unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };

   render() {
      const {handleSubmit, items, submitting, pristine, invalid, error} = this.props;
      const totalProductValue = items ? items.reduce((pre, item) => pre + (item.total), 0) : 0;
      const totalDiscount = items ? items.reduce((pre, item) => pre + (item.unit_discount * item.unit), 0) : 0;
      const totalNetWeight = items ? items.reduce((pre, item) => pre + ((item.net_weight || 0) * item.unit), 0) : 0;
      // const chargeOnOverWeight = totalNetWeight > 15000 ? ((totalNetWeight - 15000) * .0001) : 0;
      // const deliveryChange = totalProductValue < 300 ? 20 : 0;
      // const total = homeDelivery ? (totalProductValue + chargeOnOverWeight + deliveryChange) : totalProductValue;
      const {invoiceDetails} = this.state;

      return (
         <div>
            <div>
               <p>InvoiceId: {invoiceDetails.id}</p>
               <p className="text-success">Name: {invoiceDetails.contact_name}</p>
               <p className="text-success">Mobile: {invoiceDetails.contact_mobile}</p>
               <p>Prepaid Amount: {invoiceDetails.prepaidAmount}</p>
               <p>Billed Amount: {invoiceDetails.amount || 'pending'}</p>
               <p>Due: {invoiceDetails.amount ? invoiceDetails.amount_due : 'pending'}</p>
               {/*<p className="memo">Memo: {invoiceDetails.memo}</p>*/}
               <p className="text-danger createdBy">Invoice Created
                  By: {invoiceDetails.invoice_created_by}</p>
               <p>Date: {invoiceDetails.created_at}</p>
            </div>
            <form noValidate="true"
                  autoComplete="off" onSubmit={(e) => this.handleKeyDown(e)}>

               <Field name="memo" label="Memo" component={TextareaControl}/>

               <FieldArray items={items} name="items" component={RenderInventoryCounterList}/>
               {error && <strong className="input-validation-error">{error}</strong>}

               <hr/>
               <div className="pull-right">
                  <p>Total Weight: {totalNetWeight / 1000} Kg</p>
                  <p>Total Value: {totalProductValue + totalDiscount}</p>
                  <p>Total Discount: {totalDiscount},
                     Percentage: {((totalDiscount * 100) / totalProductValue).toFixed(2)}%</p>
                  {/*{homeDelivery && <p >Total Product Value: {totalProductValue}</p>}*/}
                  {/*{homeDelivery && <p >Delivery Charge: {deliveryChange}</p>}*/}
                  {/*{homeDelivery && <p >Over Weight Charge: {chargeOnOverWeight}</p>}*/}
                  <p>Net Total: {totalProductValue}</p>
               </div>
               <hr/>

               {/*<Field name="memo" label="Memo" component={TextareaControl} />*/}
               <Button type="button" bsStyle="success" block
                       onClick={handleSubmit(this.submit)}
                       disabled={submitting || pristine || invalid}>UPDATE</Button>
            </form>
         </div>
      );
   }
}

EditSaleForm.propTypes = {
   handleSubmit: PropTypes.func,
   submit: PropTypes.func,
   items: PropTypes.array,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   homeDelivery: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
   ]),
   contact_id: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.number
   ]),
   params: PropTypes.object,
   dispatch: PropTypes.func,
};

EditSaleForm.contextTypes = {
   router: PropTypes.object
};

EditSaleForm = reduxForm({ // eslint-disable-line
   form: 'editSaleForm'
})(EditSaleForm);

const selector = formValueSelector('editSaleForm');

EditSaleForm = connect(state => { // eslint-disable-line
   const items = selector(state, 'items');
   const contact_id = selector(state, 'contact_id');
   const homeDelivery = selector(state, 'homeDelivery');
   return {
      items,
      contact_id,
      homeDelivery,
   };
})(EditSaleForm);

export default EditSaleForm;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/EditSaleForm.js
 **/